import Scene from "./scrollmagic/scene";
var ScrollScene = /** @class */ (function () {
    function ScrollScene(options) {
        this.scene = new Scene(options);
        return this;
    }
    ScrollScene.prototype.triggerElement = function (value) {
        if (value !== undefined) {
            this.scene.triggerElement = this.scene.validateTriggerElement(value);
        }
        return this.scene.triggerElement;
    };
    ScrollScene.prototype.triggerHook = function (value) {
        if (value !== undefined) {
            this.scene.triggerHook = this.scene.validateTriggerHook(value);
        }
        return this.scene.triggerHook;
    };
    ScrollScene.prototype.duration = function (value) {
        if (value !== undefined) {
            this.scene.duration = this.scene.validateDuration(value);
        }
        return this.scene.duration;
    };
    ScrollScene.prototype.offset = function (value) {
        if (value !== undefined) {
            this.scene.offset = this.scene.validateOffset(value);
        }
        return this.scene.offset;
    };
    ScrollScene.prototype.reverse = function (value) {
        if (value !== undefined) {
            this.scene.reverse = this.scene.validateReverse(value);
        }
        return this.scene.reverse;
    };
    ScrollScene.prototype.progress = function (value) {
        if (value !== undefined) {
            this.scene.progress = value;
        }
        return this.scene.progress;
    };
    ScrollScene.prototype.tweenChanges = function (value) {
        if (value !== undefined) {
            this.scene.tweenChanges = value;
        }
        return this.scene.tweenChanges;
    };
    ScrollScene.prototype.setTween = function (tween, easing) {
        this.scene.setTween(tween, easing);
        return this;
    };
    ScrollScene.prototype.setClassToggle = function (element, classes) {
        this.scene.setClassToggle(element, classes);
        return this;
    };
    ScrollScene.prototype.setPin = function (element) {
        this.pinnedElement = element;
        return this;
    };
    ScrollScene.prototype.removePin = function (reset) {
        this.scene.removePin(reset);
        return this;
    };
    ScrollScene.prototype.on = function (names, callback) {
        this.scene.on(names, callback);
        return this;
    };
    ScrollScene.prototype.addIndicators = function (options) {
        this.scene.addIndicators(options);
        return this;
    };
    ScrollScene.prototype.addTo = function (controller) {
        var _this = this;
        this.controller = controller;
        if (this.pinnedElement) {
            /**
             * Workaround
             *
             * Only in the case we're using smooth scrolling.
             *
             * Since transform creates a new local coordinate system, position: fixed is fixed to the origin
             * of scrollbar content container, i.e. the left: 0, top: 0 point.
             *
             * Therefore, we need to apply offsets to make it work properly.
             * https://github.com/idiotWu/smooth-scrollbar/issues/49#issuecomment-265358197
             */
            if (this.controller.smoothScrolling) {
                var elementPosY_1 = 0;
                this.pinnedScrollListener = (function (status) {
                    if (elementPosY_1 === 0 && _this.scene.triggerElement) {
                        var elementOffsetY = _this.pinnedElement.getBoundingClientRect().top;
                        var triggerOffsetY = _this.scene.triggerElement.getBoundingClientRect().top;
                        var triggerPosY = _this.scene.duration * _this.scene.triggerHook;
                        elementPosY_1 = elementOffsetY - triggerOffsetY + triggerPosY;
                    }
                    var scrollPosY = status.offset.y;
                    var top = elementPosY_1 + scrollPosY;
                    var width = parseInt("" + _this.pinnedElement.getBoundingClientRect().width);
                    _this.pinnedElement.style.position = "fixed";
                    _this.pinnedElement.style.top = top + "px";
                    _this.pinnedElement.style.left = "";
                    _this.pinnedElement.style.width = width + "px";
                }).bind(this);
                var pinnedEnterListener = function () { var _a; return (_a = _this.controller) === null || _a === void 0 ? void 0 : _a.addScrollbarListener(_this.pinnedScrollListener); };
                var pinnedLeaveListener = function () { var _a; return (_a = _this.controller) === null || _a === void 0 ? void 0 : _a.removeScrollbarListener(_this.pinnedScrollListener); };
                this.pinnedEnterListener = pinnedEnterListener.bind(this);
                this.pinnedLeaveListener = pinnedLeaveListener.bind(this);
                this.scene.on("enter", this.pinnedEnterListener);
                this.scene.on("leave", this.pinnedLeaveListener);
            }
            else {
                this.scene.setPin(this.pinnedElement);
            }
        }
        this.scene.addTo(controller.controller);
        return this;
    };
    ScrollScene.prototype.remove = function () {
        this.scene.remove();
        /**
         * Workaround
         *
         * Only in the case we're using smooth scrolling.
         *
         * Since we're adding listeners to emulate the same pin feature that ScrollMagic has, when removing the scene,
         * we need to remove these listeners and reset the element position.
         */
        if (this.pinnedElement && this.controller && this.controller.smoothScrolling) {
            this.scene.off("enter", this.pinnedEnterListener);
            this.scene.off("leave", this.pinnedLeaveListener);
            this.controller.removeScrollbarListener(this.pinnedScrollListener);
            this.pinnedElement.style.position = "";
            this.pinnedElement.style.top = "";
            this.pinnedElement.style.width = "";
        }
        this.controller = undefined;
        return this;
    };
    ScrollScene.prototype.refresh = function () {
        this.scene.refresh();
        return this;
    };
    return ScrollScene;
}());
export default ScrollScene;
//# sourceMappingURL=scroll-scene.js.map